<template>
  <div>

    <!-- --------- Object Information ---------- -->
    <b-row class="border-bottom mb-2">
      <b-col>
        <h4 class="mb-0">
          Object Name & Type
        </h4>
        <small class="text-muted mt-0">
          Enter Name and Object Type
        </small>
      </b-col>
    </b-row>

    <b-row>
      <!-- Object Name -->
      <b-col>
        <b-form-group
          label="Object Name"
          label-for="objectNameInput"
        >

          <b-form-input
            id="objectNameInput"
            v-model="newObject.info.name"
            :state="newObject.info.name.length > 0 "
            placeholder="A name for your object"
          />

          <b-col>
            <small class="text-muted">
              Serial Number is recommended as a name for the object
            </small>
          </b-col>
        </b-form-group>
      </b-col>

    </b-row>
    <b-row>
      <!-- Object Type -->
      <b-col>
        <b-form-group
          label="Object Type"
          label-for="objectTypeInput"
        >

          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="name"
            taggable
            push-tags
            :options="objectTypes"
            @input="setSelected"
          />

        </b-form-group>
      </b-col>
    </b-row>

    <!-- --------- Tags
    <b-row>
      <b-col>
        <b-form-group
          label="Tags"
          label-for="manufacturerModel"
        >
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            multiple
            taggable
            push-tags
            placeholder="Add tags"
            label="title"
            :options="['tag1','tag2']"
            :v-model="selectedTags"
          />
        </b-form-group>
      </b-col>
    </b-row>
---------- -->

    <!---- Object Image
    <b-row class="mt-2 ">
      <b-col>
        <b-card>
          <b-col>
            <div class="d-flex justify-content-center">
              <h2>
                Select Existing Image
              </h2>
            </div>
          </b-col>

          <b-col>
            <b-form-group
              label-for="Image"
            >
              <v-select
                v-model="selectedObjectImage"
                label="name"
                placeholder="No Image"
                :options="objectImages"
              />
            </b-form-group>
          </b-col>

          <b-col>
            <div class="d-flex justify-content-center">
              <h1>
                Or
              </h1>
            </div>
          </b-col>

          <b-col>
            <vue-dropzone
              id="dropzone"
              ref="myVueDropzone"
              :options="dropzoneOptions"
            />
          </b-col>

        </b-card>
      </b-col>
    </b-row>
    --->

  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  // BCard,
} from 'bootstrap-vue'
// import vue2Dropzone from 'vue2-dropzone'
import vSelect from 'vue-select'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  components: {
    // BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    // vueDropzone: vue2Dropzone,
    vSelect,
  },
  props: {
    newObject: {
      type: Object,
      required: true,
    },
    objectTypes: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      changeId: '',
      selectedTags: [],
      objectImages: [],
      selectedObjectImage: {},
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 300,
        maxFilesize: 0.5,
        headers: { 'My-Awesome-Header': 'header value' },
        dictDefaultMessage: '<h2>Drop image here to upload</h2>',
      },
    }
  },
  watch: {
    deep: true,
    handler(newVal) {
      this.newObject = newVal
    },
  },
  methods: {
    setSelected(value) {
      if (value === null) {
        this.newObject.info.type = value
      } else if (value.id === undefined) {
        this.newObject.info.type = {
          name: value,
        }
      } else {
        this.newObject.info.type = value
      }
    },
  },
}

</script>

<style>

</style>
